// extracted by mini-css-extract-plugin
module.exports = {"header":"aw0buxZWbuyM7jXrYL_0g","winnerPendingContainer":"_2RWwNHBdkJsWbeXAnnWrG-","winnerPendingContent":"_3YdS0MBcQvseM3A03nZRwx","pendingDate":"_1tQ51h0PKKkZBiYQusMrfw"};